import { axios } from '@/utils/request'

export function getProgramsList(params) {
    return axios({
        url: '/programs/',
        method: 'get',
        params
    })
}
